"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'remoteRecord';
exports.FETCH_DECODERS = exports.namespace + "/FETCH_DECODERS";
exports.RECORD = exports.namespace + "/REQUEST_RECORD";
exports.RESET_REMOTE_RECORD = exports.namespace + "/RESET_REMOTE_RECORD";
//# sourceMappingURL=constants.js.map